module.exports = __webpack_public_path__ + "img/sboxlogo.d7b990b1.png";